import App from "../App";

const Home = () => {
  return <App/>;
};

export default Home;